<template>
  <div>
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin-bottom:40px"
    >
      <el-breadcrumb-item :to="{ path: '/userTab' }"
        >企业信息</el-breadcrumb-item
      >
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="xingxidanhao">
      <el-row :gutter="20">
        <el-col :span="12" :push="2">
          <p style="margin-top: 20px;">
            <b>单号：</b><b>{{ testData.id }}</b>
          </p>
          <p style="font-size: 14px;margin-top: 20px;">
            <i>订单类型：</i><i>{{ this.orderText.data.type }}</i>
          </p>

          <p style="font-size: 14px;">
            <i>创建时间：</i><i>{{ testData.createTime }}</i>
          </p>
          <!-- <p style="font-size: 14px;" v-if="this.progress !== 1">
              <i>总 价：</i><i>{{ detailed.zongjia }}</i>
            </p> -->
        </el-col>
        <el-col :span="12" :push="7">
          <!-- <p
              style="font-size: 14px; margin-top: 70px;"
              v-if="this.progress === 2 || this.progress === 3"
            >
              <i>定金: </i><b>{{ detailed.dingjing }}</b>
            </p> -->
          <!-- <p
              style="font-size: 14px; margin-top: 70px;"
              v-if="this.progress === 5 || this.progress === 4"
            >
              <i>尾款: </i><b>{{ detailed.weikuan }}</b>
            </p> -->
          <!-- <el-button
              @click="payment()"
              type="success"
              v-if="this.progress === 2"
              >支付定金</el-button
            >
            <el-button
              @click="payment()"
              type="success"
              v-if="this.progress === 5"
              >支付尾款</el-button
            >
            <el-button
              type="success"
              v-if="this.progress === 4"
              @click="check()"
              >项目验收</el-button
            > -->
        </el-col>
      </el-row>
    </div>

    <!-- 驳回信息 -->
    <el-card style="margin-top: 20px;" v-if="this.testData.status == 2">
      <el-row>
        <el-col :span="8" :push="2">
          <h4>驳回原因</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <p>{{ this.detailed.bohuiyuanyin }}</p>
        </el-col>
      </el-row>
    </el-card>
    <!-- 项目信息 -->
    <el-card style="margin-top: 20px;">
      <el-row>
        <el-col :span="8" :push="2">
          <h4>项目信息</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <div class="xianshi ">
            <p>
              <b>项目名称:</b>
              <i> {{ testData.name }}</i>
            </p>
            <p>
              <b>项目所在地:</b>
              <i> {{ detailed.suozaidi }}</i>
            </p>
          </div>
          <div class="xianshi ">
            <p>
              <b>项目获取时间：</b>
              <i> {{ detailed.shijianDuan }}</i>
            </p>
            <p>
              <b>报价:</b>
              <i> ￥{{ detailed.projectBudget }}元</i>
            </p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!-- 数据处理采集手段 -->
    <el-card
      style="margin-top: 20px;"
      v-if="this.testData.type == 2 || this.testData.type == 3"
    >
      <el-row>
        <el-col :span="8" :push="2">
          <h4>数据成果</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <div class="xianshi ">
            <p>
              <b>{{ detailed.caijishouduan }}</b>
            </p>
          </div>
          <!-- <div class="xianshi right">
              <p>
                <b>DSM（数字表面模型）</b>
              </p>
            </div> -->
        </el-col>
      </el-row>
    </el-card>
    <el-card
      style="margin-top: 20px;"
      v-if="this.detailed.hasOwnProperty('MonomerModel')"
    >
      <el-row>
        <el-col :span="8" :push="2">
          <h4>单体模型要求</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <div class="xianshi ">
            <p>
              <b>{{ detailed.MonomerModel }}</b>
            </p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card
      style="margin-top: 20px;"
      v-if="this.detailed.hasOwnProperty('semanticModel')"
    >
      <el-row>
        <el-col :span="8" :push="2">
          <h4>语义模型要求</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <div class="xianshi ">
            <p>
              <b>{{ detailed.semanticModel }}</b>
            </p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card
      style="margin-top: 20px;"
      v-if="this.detailed.hasOwnProperty('BIM')"
    >
      <el-row>
        <el-col :span="8" :push="2">
          <h4>BIM要求</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <div class="xianshi ">
            <p>
              <b>{{ detailed.BIM }}</b>
            </p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!-- 数据采集采集手段 -->
    <el-card
      style="margin-top: 20px;"
      v-if="this.testData.type == 1 || this.testData.type == 3"
    >
      <el-row>
        <el-col :span="8" :push="2">
          <h4>采集手段</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <div class="xianshi ">
            <p v-if="this.detailed.hasOwnProperty('QinXieSheYin')">
              <b style="font-size: 16px;">倾斜摄影</b>
            </p>
            <p v-if="this.detailed.hasOwnProperty('QinXieSheYin')">
              <b>航飞分辨率: </b>
              <i>{{ detailed.QinXieSheYin.HangFeiFenBian }}</i>
            </p>
            <div
              style="height:15px"
              v-if="this.detailed.hasOwnProperty('HangKongSheYing')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('HangKongSheYing')">
              <b style="font-size: 16px;">航空摄影</b>
            </p>
            <p v-if="this.detailed.hasOwnProperty('HangKongSheYing')">
              <b>航飞分辨率: </b>
              <i>{{ detailed.HangKongSheYing.HangFeiFenBian }}</i>
            </p>
            <div
              style="height:15px"
              v-if="this.detailed.hasOwnProperty('WeiXinYinXiang')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('WeiXinYinXiang')">
              <b style="font-size: 16px;">卫星影像</b>
            </p>
            <p v-if="this.detailed.hasOwnProperty('WeiXinYinXiang')">
              <b>航飞分辨率: </b>
              <i>{{ detailed.WeiXinYinXiang.HangFeiFenBian }}</i>
            </p>
            <div
              style="height:15px"
              v-if="this.detailed.hasOwnProperty('HangKongDianYun')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('HangKongDianYun')">
              <b style="font-size: 16px;">航空点云</b>
            </p>
            <p v-if="this.detailed.hasOwnProperty('HangKongDianYun')">
              <b>平均点密度: </b>
              <i>{{ detailed.HangKongDianYun.MiDu }}点/平方米</i>
            </p>
            <div
              style="height:15px"
              v-if="this.detailed.hasOwnProperty('slam')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('slam')">
              <b style="font-size: 16px;">地面slam</b>
            </p>
            <p v-if="this.detailed.hasOwnProperty('slam')">
              <b>精度要求: </b>
              <i>{{ detailed.slam }}cm</i>
            </p>
            <div
              style="height:15px"
              v-if="this.detailed.hasOwnProperty('DuoGuang')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('DuoGuang')">
              <b style="font-size: 16px;">多光谱遥感</b>
            </p>
            <p v-if="this.detailed.hasOwnProperty('DuoGuang')">
              <b>航飞分辨率: </b>
              <i>{{ detailed.DuoGuang.HangFeiFenBian }}</i>
            </p>
            <div
              style="height:15px"
              v-if="this.detailed.hasOwnProperty('HongRe')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('HongRe')">
              <b style="font-size: 16px;">热红外呈像</b>
            </p>
            <p v-if="this.detailed.hasOwnProperty('HongRe')">
              <b>航飞分辨率: </b>
              <i>{{ detailed.HongRe.HangFeiFenBian }}</i>
            </p>
          </div>
          <div class="xianshi">
            <p v-if="this.detailed.hasOwnProperty('QinXieSheYin')">
              <b>航摄比例尺: </b>
              <i>{{ detailed.QinXieSheYin.HangSheBiLiChi }}</i>
            </p>
            <div
              style="height:80px"
              v-if="this.detailed.hasOwnProperty('HangKongSheYing')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('HangKongSheYing')">
              <b>航摄比例尺: </b>
              <i>{{ detailed.HangKongSheYing.HangSheBiLiChi }}</i>
            </p>
            <div
              style="height:80px"
              v-if="this.detailed.hasOwnProperty('WeiXinYinXiang')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('WeiXinYinXiang')">
              <b>航摄比例尺: </b>
              <i>{{ detailed.WeiXinYinXiang.HangSheBiLiChi }}</i>
            </p>
            <div
              style="height:80px"
              v-if="this.detailed.hasOwnProperty('HangKongDianYun')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('HangKongDianYun')">
              <b>航摄比例尺: </b>
              <i>{{ detailed.HangKongDianYun.HangSheBiLiChi }}</i>
            </p>
            <div
              style="height:80px"
              v-if="this.detailed.hasOwnProperty('slam')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('slam')">
              <b></b>
              <i></i>
            </p>
            <div
              style="height:80px"
              v-if="this.detailed.hasOwnProperty('DuoGuang')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('DuoGuang')">
              <b>航摄比例尺: </b>
              <i>{{ detailed.DuoGuang.HangSheBiLiChi }}</i>
            </p>
            <div
              style="height:80px"
              v-if="this.detailed.hasOwnProperty('HongRe')"
            ></div>
            <p v-if="this.detailed.hasOwnProperty('HongRe')">
              <b>航摄比例尺: </b>
              <i>{{ detailed.HongRe.HangSheBiLiChi }}</i>
            </p>
            <div style="height:80px"></div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!-- 采集区域 -->
    <el-card
      style="margin-top: 20px;"
      v-if="this.testData.type == 1 || this.testData.type == 3"
    >
      <el-row>
        <el-col :span="8" :push="2">
          <h4>采集区域</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <div class="xianshi">
            <p>
              <b>作业区域范围</b>
            </p>

            <p v-if="this.detailed.hasOwnProperty('fanaweiwenjian')">
              <img src="../../assets/img/kml.png" alt="" />
            </p>
            <p v-if="this.detailed.hasOwnProperty('QuYuWenJian')">
              <img src="../../assets/img/kml.png" alt="" />
            </p>
            <p v-if="this.detailed.hasOwnProperty('lng')">
              <b>中心点经度: </b>
              <i>{{ detailed.lng }}</i>
            </p>
            <p v-if="this.detailed.hasOwnProperty('lat')">
              <b>中心点纬度: </b>
              <i>{{ detailed.lat }}</i>
            </p>
            <p v-if="this.detailed.hasOwnProperty('zuobiaobanjin')">
              <b>半径: </b>
              <i>{{ detailed.zuobiaobanjin }}</i>
            </p>
          </div>
          <div class="xianshi">
            <p>
              <b>作业区域地貌: </b>
              <i>{{ detailed.DiMao }}</i>
            </p>
            <p>
              <b>作业区域面积: </b>
              <i>{{ detailed.MianJi }}平方公里</i>
            </p>
            <p>
              <b>空域服务: </b>
              <i>{{ detailed.KongYu }}</i>
            </p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!-- 成果要求 -->
    <el-card
      style="margin-top: 20px;"
      v-if="this.testData.type == 2 || this.testData.type == 3"
    >
      <el-row>
        <el-col :span="8" :push="2">
          <h4>成果要求</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <div class="xianshi" v-if="this.testData.type == 2">
            <p>
              <b>成果精度：</b>
              <i>{{ detailed.chengguojindu }}</i>
            </p>
          </div>
          <div class="xianshi">
            <p>
              <b>坐标系要求：</b>
              <i>{{ detailed.zuobiaoxi }}</i>
            </p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!-- 源数据信息 -->
    <el-card style="margin-top: 20px;" v-if="this.testData.type == 2">
      <el-row>
        <el-col :span="8" :push="2">
          <h4>源数据信息</h4>
        </el-col>
        <el-col :span="16" :pull="2" class="rightbox">
          <div class="xianshi">
            <p>
              <b>航飞分辨率：</b>
              <i>{{ detailed.hangfeifenbianlv }}</i>
            </p>
            <p>
              <b>飞行器类型：</b>
              <i>{{ detailed.feixinqixingxi.feixingqileixin }}</i>
            </p>
            <p>
              <b>控制点：</b>
              <i>{{ detailed.kongzhidian }}</i>
            </p>
            <p>
              <b>航摄仪信息</b>
            </p>
            <p>
              <b>航摄仪型号：</b>
              <i>{{ detailed.hangsheyixinghao }}</i>
            </p>
            <p>
              <b>传感器宽度：</b>
              <i>宽：{{ detailed.chuanganqikuandu }}</i>
            </p>
            <p>
              <b>镜头数量：</b>
              <i>{{ detailed.jintoushuliang }}</i>
            </p>
            <p>
              <b>布控需求：</b>
              <i>{{ detailed.bukongxuqiu }}</i>
            </p>
          </div>
          <div class="xianshi">
            <p>
              <b>照片数量：</b>
              <i>{{ detailed.zhaopianshuliang }}</i>
            </p>
            <p>
              <b>飞行器型号：</b>
              <i>{{ detailed.feixinqixingxi.feixingqixinhao }}</i>
            </p>
            <!-- <p>
                <b>控制点数量：</b>
                <i>{{ detailed.data.kongzhidian.shuliang }}</i>
              </p> -->
            <div style="height:55px"></div>
            <p>
              <b>相幅宽度：</b>
              <i>{{ detailed.xiangfukuandu }}</i>
            </p>
            <p>
              <b>镜头焦距：</b>
              <i>{{ detailed.jintoujiaoju }}</i>
            </p>
            <p>
              <b>影像格式：</b>
              <i>{{ detailed.yingxianggeshi }}</i>
            </p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!-- 测区范围 -->
    <el-card
      style="margin-top: 20px;"
      v-if="this.testData.type == 2 || this.testData.type == 3"
    >
      <el-row>
        <el-col :span="8" :push="2">
          <h4>测区范围</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <div class="xianshi">
            <p>
              <b>作业区域范围</b>
            </p>
            <p v-if="this.detailed.hasOwnProperty('fanaweiwenjian')">
              <img src="../../assets/img/kml.png" alt="" />
            </p>
            <p v-if="this.detailed.hasOwnProperty('QuYuWenJian')">
              <img src="../../assets/img/kml.png" alt="" />
            </p>
            <p v-if="this.detailed.hasOwnProperty('lng')">
              <b>中心点经度: </b>
              <i>{{ detailed.lng }}</i>
            </p>
            <p v-if="this.detailed.hasOwnProperty('lat')">
              <b>中心点纬度: </b>
              <i>{{ detailed.lat }}</i>
            </p>
            <p v-if="this.detailed.hasOwnProperty('zuobiaobanjin')">
              <b>半径: </b>
              <i>{{ detailed.zuobiaobanjin }}</i>
            </p>
          </div>
          <div class="xianshi" v-if="this.testData.type == 2">
            <p>
              <b>作业区域面积: </b>
              <i>{{ detailed.zuoyemianji }}平方公里</i>
            </p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!-- 附件信息 -->
    <el-card style="margin-top: 20px;">
      <el-row>
        <el-col :span="8" :push="2">
          <h4>附件信息</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <p></p>
          <i>{{ detailed.FuJianWenJian }}</i>
        </el-col>
      </el-row>
    </el-card>
    <!-- 备注 -->
    <el-card style="margin-top: 20px;margin-bottom:30px">
      <el-row>
        <el-col :span="8" :push="2">
          <h4>备 注</h4>
        </el-col>
        <el-col :span="16" :pull="2">
          <div class=" xianshi">
            <i>{{ detailed.BeiZhu }}</i>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      progress: 5,
      testData: {},
      orderText: {},
      caijishouduan: {},
      orderData: {
        function: "t_order",
        condition: ""
      },
      detailed: {}
    };
  },
  // beforeDestroy() {
  //   localStorage.removeItem("orderData");
  // },
  created() {
    this.getRouterData();
  },
  methods: {
    async getRouterData() {
      const orderData = sessionStorage.getItem("orderData");
      if (orderData) {
        this.orderText = JSON.parse(orderData);
      } else {
        this.orderText = this.$route.params;

        sessionStorage.setItem("orderData", JSON.stringify(this.$route.params));
      }
      this.orderData.condition = `userId=${this.orderText.data.userId} and id='${this.orderText.data.id}'`;
      const { data: dt } = await this.$http.post(
        "general/query",
        this.orderData
      );
      if (dt.status == 500) {
        this.$confirm("身份认证过期请重新登陆", "退出", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            window.sessionStorage.removeItem("token");
            // window.sessionStorage.removeItem("tempData");
            this.$router.push("/login");
          })
          .catch(() => {});
      }
      // dt.data.forEach(element => {

      // });
      this.testData = dt.data[0];
      // this.testData.forEach(e=>{

      // })
      this.detailed = JSON.parse(this.testData.data);

      if (this.testData.type == 1 || this.testData.type == 3) {
        if (this.detailed.hasOwnProperty("QinXieSheYin")) {
          if (typeof this.detailed.QinXieSheYin == "string") {
            this.detailed.QinXieSheYin = JSON.parse(this.detailed.QinXieSheYin);
          }
        }
        if (this.detailed.hasOwnProperty("HangKongSheYing")) {
          if (typeof this.detailed.HangKongSheYing == "string") {
            this.detailed.HangKongSheYing = JSON.parse(
              this.detailed.HangKongSheYing
            );
          }
        }
        if (this.detailed.hasOwnProperty("WeiXinYinXiang")) {
          if (typeof this.detailed.WeiXinYinXiang == "string") {
            this.detailed.WeiXinYinXiang = JSON.parse(
              this.detailed.WeiXinYinXiang
            );
          }
        }
        if (this.detailed.hasOwnProperty("HangKongDianYun")) {
          if (typeof this.detailed.HangKongDianYun == "string") {
            this.detailed.HangKongDianYun = JSON.parse(
              this.detailed.HangKongDianYun
            );
          }
        }
        if (this.detailed.hasOwnProperty("DuoGuang")) {
          if (typeof this.detailed.DuoGuang == "string") {
            this.detailed.DuoGuang = JSON.parse(this.detailed.DuoGuang);
          }
        }
        if (this.detailed.hasOwnProperty("slam")) {
          this.detailed.slam;
        }
        if (this.detailed.hasOwnProperty("HongRe")) {
          if (typeof this.detailed.HongRe == "string") {
            this.detailed.HongRe = JSON.parse(this.detailed.HongRe);
          }
        }
      } else if (this.testData.type == 2) {
        if (typeof this.detailed.feixinqixingxi == "string") {
          this.detailed.feixinqixingxi = JSON.parse(
            this.detailed.feixinqixingxi
          );
        }

        // if (this.detailed.hasOwnProperty("kongzhidian")) {

        //     this.detailed.kongzhidian

        // }
      }
    },
    payment() {
      this.$router.push("/payment");
    },
    check() {
      this.$router.push("/check");
    }
  }
};
</script>

<style lang="less" scoped>
// .rightbox {
//   position: relative;
// }
// .el-card {
//   overflow: auto;
// }
.box {
  background: #f2f2f2;
}
.xianshi {
  font-size: 14px;
  // display: inline-block;
  i {
    color: #a9acbb;
  }
}
.left {
  float: left;
}
.right {
  float: right;
  margin-right: 200px;
}

.xingxidanhao {
  // margin-top: 30px;
  height: 180px;
  background-color: #0086fd;
  p {
    color: #fff;
  }
}
li {
  list-style-type: none;
  float: left;
  margin-right: 170px;
}
li:last-child {
  margin-right: 0;
}
.ding {
  height: 20px;
  margin-top: 60px;
}
.fanhui {
  float: right;
}
i {
  font-style: normal;
}
</style>
